import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Custom Framing</p>
        <h1>Transform Your Memories into Art</h1>
        <p className="lede">
          Discover our custom framing services designed to showcase your art, photos, and memorabilia beautifully. 
          Elevate your space with personalized frames that reflect your style.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_self">
            Shop Now
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Quality Craftsmanship</h2>
          <p>
            Our frames are crafted with precision and care, ensuring your cherished items are displayed beautifully and securely.
          </p>
        </article>
        <article>
          <h2>Endless Customization</h2>
          <p>
            Choose from a variety of styles, colors, and materials to create a frame that perfectly complements your artwork.
          </p>
        </article>
        <article>
          <h2>Fast and Convenient</h2>
          <p>
            Enjoy a seamless online shopping experience with quick turnaround times, so you can enjoy your framed pieces sooner.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;